<div class="execution-cycle-view">
  <!-- Title -->
  <h2 class="view-title">Execution Cycles</h2>

  <!-- Header Card -->
  <div class="header-card">
    <span class="showing-text">
      Showing <strong>{{ showingStart }}</strong> to <strong>{{ showingEnd }}</strong> of <strong>{{ totalItems }}</strong> execution cycles
    </span>

    <div class="header-actions">
      <button
        class="action-btn delete-btn"
        [disabled]="selectedCount === 0"
        (click)="onDeleteClick()">
        <img src="assets/images/virtusa-icons/delete-red.svg" alt="Delete" />
        Delete
      </button>

      <button class="action-btn refresh-btn" (click)="onRefreshClick()">
        <img src="assets/images/virtusa-icons/refresh.svg" alt="Refresh" />
        Refresh
      </button>
    </div>
  </div>

  <!-- Execution Cycles List -->
  <div class="cycles-container">

    <!-- Skeleton rows while loading -->
    <div *ngIf="isLoading" class="placeholder-glow">
      <div *ngFor="let _ of skeletonRows" class="cycle-skeleton-row mb-3 p-3 rounded" style="background:#f8f9fa;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="placeholder col-4" style="height:16px;"></span>
          <span class="placeholder col-2" style="height:16px;"></span>
        </div>
        <span class="placeholder col-7 d-block mb-2" style="height:12px;"></span>
        <div class="d-flex gap-2">
          <span class="placeholder col-2" style="height:10px;"></span>
          <span class="placeholder col-2" style="height:10px;"></span>
          <span class="placeholder col-2" style="height:10px;"></span>
          <span class="placeholder col-2" style="height:10px;"></span>
        </div>
      </div>
    </div>

    <!-- Empty state (only when not loading) -->
    <div *ngIf="!isLoading && executionCycles.length === 0" class="empty-state">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="#f3f4f6"/>
        <path d="M32 20v24M20 32h24" stroke="#9ca3af" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <p class="empty-text">No execution cycles found</p>
    </div>

    <app-execution-cycle-card
      *ngFor="let cycle of displayedCycles"
      [style.display]="isLoading ? 'none' : null"
      [cycle]="cycle"
      [badge]="getBadgeText(cycle)"
      [isChecked]="isSelected(cycle.id)"
      (checkboxChange)="onCheckboxChange($event)"
      (viewDetails)="onViewDetails($event)">
    </app-execution-cycle-card>
  </div>

  <!-- Pagination -->
  <div *ngIf="showPagination && totalItems > pageSize" class="pagination-container">
    <nz-pagination
      [nzPageIndex]="currentPage"
      [nzTotal]="totalItems"
      [nzPageSize]="pageSize"
      [nzShowSizeChanger]="false"
      (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>
</div>
